module.exports = __webpack_public_path__ + "img/combination_text@2x.33091fd.jpg";